import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Watch } from 'vue-property-decorator';

@Component({
})
export default class OrderFilterPanel extends Vue {
    search = ''
    loading = false
    timerId: number | null = null
    timerDelay = 500
    @Emit() searchChange() {
        return {
            search: this.search ? this.search : ''
        }
    }
    @Watch('search') onSearch(val: string, oldVal: string) {
        if (val === null) {
            if (this.timerId !== null) clearTimeout(this.timerId)
            return;
        }
        if (this.timerId !== null) clearTimeout(this.timerId)
        this.timerId = setTimeout(() => this.searchChange(), this.timerDelay)
    }
    clear() {
        this.$nextTick(() => {
            this.searchChange()
        })
    }
}